import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface RadioOption {
    value: string;
    label: string;
}

@customElement('radio-group')
export class RadioGroup extends LitElement {
    @property({ type: String }) labelId = '';
    @property({ type: String }) label = '';
    @property({ type: Array }) options: RadioOption[] = [];
    @property({ type: String, reflect: true }) selected = '';
    @property({ type: String }) name = '';
    @property({ type: String }) info = '';

    createRenderRoot() {
        return this;
    }

    render() {
        return html`
            <div class="mb-10">
                ${this.label ? html`<p class="block preamble pb-4">${this.label}</p>` : ''}
                <div class="flex flex-wrap gap-4">
                    ${this.options.map((option) => html`
                        <label for="${this.labelId + "-" + option.value}" class="flex items-center cursor-pointer">
                            <input
                                id="${this.labelId + "-" + option.value}"
                                type="radio" 
                                name=${this.name}
                                .value=${option.value}
                                .checked=${this.selected === option.value}
                                @change=${this.onChange}
                                class="hidden peer"
                            />
                            <div class="w-6 h-6 border-4 border-neutral border-inset bg-neutral peer-checked:bg-white-on-shadow relative flex items-center justify-center">
                            </div>
                            <span class="p ml-2 md:ml-3 mr-2 md:mr-8">${option.label}</span>
                        </label>
                    `)}
                    <span class="small italic text-price mt-1">${this.info}</span>
                </div>
            </div>
        `;
    }

    private onChange(e: Event) {
        const value = (e.target as HTMLInputElement).value;
        this.selected = value;
        this.dispatchEvent(new CustomEvent('value-change', {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
}